import "./src/styles/global.scss";
import { grantAnalyticsConsent, trackPageView, isGADebugMode } from "./src/utils/analytics";
import { getCookieConsentState } from "./src/utils/cookieConsent";

export const onClientEntry = () => {
  const consent = getCookieConsentState();
  console.info(
    `[CCS Analytics] consent=${consent} | trackingId=${process.env.GATSBY_GA_TRACKING_ID ?? "G-KXLZFNN916"} | debugMode=${isGADebugMode()}`
  );

  // If the user already accepted consent in a previous session, grant it now
  // so GA can start collecting from this page load.
  if (consent === "accepted") {
    grantAnalyticsConsent();
  }
};

export const onRouteUpdate = ({ location }) => {
  const savedScroll = sessionStorage.getItem("cc_lang_scroll");
  if (savedScroll !== null) {
    sessionStorage.removeItem("cc_lang_scroll");
    const y = parseInt(savedScroll, 10);
    if (!isNaN(y)) {
      requestAnimationFrame(() => window.scrollTo({ top: y, behavior: "instant" }));
    }
  }

  if (getCookieConsentState() !== "accepted") return;

  const pagePath = location
    ? `${location.pathname}${location.search}${location.hash}`
    : undefined;

  // Double rAF + setTimeout(0) ensures i18n has updated document.title
  // before the page_view event reads it.
  if ("requestAnimationFrame" in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => void trackPageView(pagePath), 0);
      });
    });
    return;
  }

  setTimeout(() => void trackPageView(pagePath), 50);
};
